export class BookingItem {
    id: number;
    code: string;
    name: string;
    lunch: boolean;
    payment_method: string;
    price: BookingPrice;
    status: string;
    survey: string;
    created_at: string;
    updated_at: string;
    semester_id: number;
    hol_student_id: string;
    hol_parent_id: number;
    hol_class_id: number;
    hol_class: HolidayClass;
    hol_booking_buses: HolidayBuses[];
    hol_weeks: HolidayWeek[];
    hol_student: HolidayStudent;
    transactions: BookingTransactions[];
    note: string;
    constructor() {
        this.hol_class = new HolidayClass;
        this.hol_weeks = [];
        this.hol_student = new HolidayStudent;
        this.price = new BookingPrice;
        this.hol_booking_buses = new Array<HolidayBuses>();
        this.transactions = new Array<BookingTransactions>();
    }
}
class BookingTransactions {
    action: string;
    amount: number;
    created_at: string;
    hol_booking_id: string;
    id: number;
    method: any;
    note: any;
    type: string;
}
export class HolidayBuses {
        address: string;
        district: string;
        hol_booking_id: number;
        id: number;
        price: number
}
export class BookingList {
    count: number;
    data: ListBookingItem[];
    constructor() {
        this.count = 0
        this.data = []
    }
}

export class ListBookingItem {
    id: number;
    code: string;
    name: string;
    lunch: boolean;
    payment_method: string;
    price: BookingPrice;
    status: string;
    survey: string;
    created_at: string;
    updated_at: string;
    semester_id: number;
    hol_student_id: string;
    hol_parent_id: number;
    hol_class_id: number;
    hol_class: HolidayClass;
    hol_booking_buses: any[];
    hol_weeks: HolidayWeek[];
    hol_student: HolidayStudent;
    transactions: BookingTransactions[];
    note: string;
    constructor() {
    }
};
export class HolidayClass {
    id: number;
    name: string;
    room: string;
    teacher: string;
    max_number: number;
    total_cost: number;
    cost_per_week: number;
    activities: string;
    suitable_from: string;
    suitable_to: string;
    status: string;
    hol_course_id: number;
    campus_id: number;
    thumbnail_id: string;
    campus: CampusInfo;
    constructor() {
        this.campus = new CampusInfo;
    }
} 
export class CampusInfo {
    id: number;
    name: string
}

export class BookingPrice {
    bus: number;
    lunch: number;
    total: number;
    origin: number;
    booking: number;
    discounted: number;
};
export class HolidayWeek {
    id: number;
    name: string;
    start_date: string;
    end_date: string;
    lunch_cost: number;
    hol_booking_week: HolidayBookingWeek;
}
export class HolidayBookingWeek {
    excursions: any[];
    hol_week_id: number;
    hol_booking_id: string 
}

export class HolidayStudent {
    id: string;
    code: number;
    family_name: string;
    given_name: string;
    known_name: string;
    gender: string;
    date_of_birth: string;
    country: string;
    medical: string
}

export class LunchStatus {
    id: string;
    name: string;
}

export const LUNCH_STATUS: LunchStatus[] = [
    {
        id: 'true',
        name: 'Yes'
    },
    {
        id: 'false',
        name: 'No'
    }
];

export class WeekList {
    id: number;
    name: string;
}

export const WEEK_LIST: WeekList[] = [
    {
        id: 1,
        name: 'Week 1'
    },
     {
        id: 2,
        name: 'Week 2'
    },
     {
        id: 3,
        name: 'Week 3'
    },
     {
        id: 4,
        name: 'Week 4'
    },
     {
        id: 5,
        name: 'Week 5'
    },
     {
        id: 6,
        name: 'Week 6'
    },
    {
        id: 7,
        name: 'Week 7'
    },
];

export class TransactionDetail {
    balance: number;
    buses: TransactionBuses[];
    class: ClassTransaction;
    createAt: string;
    id: string;
    price: TransactionPrice;
    semester: TransactionSemester;
    status: string;
    transactions: HolTransactions[];
    student: TransactionStudent;
    constructor() {
        this.price = new TransactionPrice;
        this.semester = new TransactionSemester;
        this.student = new TransactionStudent;
        this.transactions = new Array<HolTransactions>();
        this.buses = new Array<TransactionBuses>();
    }
}
class TransactionBuses {
    address: string;
    district: string;
}
export class HolTransactions {
    action: string
    amount: number
    createdAt: string
    method: string
    note: string
    type: string
}
export class ClassTransaction {
    id: number;
    name: string;
}
export class TransactionPrice {
    booking: number;
    bus: number;
    discounted: number;
    lunch: number;
    origin: number;
    total: number
}
export class TransactionSemester {
    id: number;
    name: string;
    schoolYearId: number
}
export class TransactionStudent {
    aisId: number;
    dob: string;
    familyName: string;
    fivenName: string;
    homeroom: any[];
    id: string;
    medical: any;
    parents: TransactionParents[];
    constructor() {
        this.parents = new Array<TransactionParents>();
    }
}
export class TransactionParents {
    id: number;
    parentDetails: any;
    siblings: any;
}
export class MakeHolTransaction {
    bookingId: string;
    command: HolTransactionCommand;
    constructor() {
        this.command = new HolTransactionCommand;
    }
}
export class UpdateHolTransaction {
    command: UpdateHolTransactionCommand;
    constructor() {
        this.command = new UpdateHolTransactionCommand;
    }
}
export class UpdateHolTransactionCommand {
    id: any;
    action: any;
    type: any;
    method: any;
    note: any;
    hol_booking_id: any;
    amount: number;
}
class HolTransactionCommand {
    action: string;
    amount: number;
    type: string;
    note: string;
    method: string;
    hol_booking_id: string;
}

export class DeleteHolTransaction {
    id: any;
    hol_booking_id: any;
}


// WEBPACK FOOTER //
// ./src/holiday/models/Booking.ts